
export const prepocetSj = (pocetVjOld: number, pocetVjNew: number, hodnota: number, isMultiplication: boolean) => {
	if (pocetVjNew > 0) {
		const pomer = pocetVjOld * 1.0 / pocetVjNew;
		return isMultiplication ? hodnota * pomer : hodnota / pomer;
	}
	return hodnota;
};
